import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const {
  API_URL: api,
  FRONTEND_URL: app,
  BASE_PATH: base,
  RECAPTCHA_SITE_KEY: recaptcha,
  GOOGLE_GTM_ID: gtm,
  TEALIUM_ENV: tealium,
  ADOBE_LAUNCH: adobeLaunch,
  SENTRY_DSN: sentry,
  NODE_ENV: node,
  HOTJAR_ID: hotjar,
  GTM_QUIZ_NAME: quizname,
  DAVIDS_URL: davids,
  PEARL_URL: pearl,
  OPTIMIZE_ID: optimize,
  APPSTORE_ID: appstore,
} = publicRuntimeConfig;

export const API_URL = api;
export const FRONTEND_URL = app;
export const BASE_PATH = base;
export const RECAPTCHA_SITE_KEY = recaptcha;
export const GOOGLE_GTM_ID = gtm;
export const TEALIUM_ENV = tealium;
export const ADOBE_LAUNCH = adobeLaunch;
export const SENTRY_DSN = sentry;

export const NODE_ENV: 'production' | 'stage' | 'test' | 'development' = node;
export const HOTJAR_ID = hotjar;
export const GTM_QUIZ_NAME = quizname;
export const DAVIDS_URL = davids;
export const PEARL_URL = pearl;
export const OPTIMIZE_ID = optimize;
export const APPSTORE_ID = appstore;

export const ONCHANGE_LIST = ['DATE_LEFT', 'INSERT_VALUES'];
